<template>
  <b-col
    cols="12"
    lg="6"
    class="mb-4"
  >
    <b-card>
      <template #header>
        <h4 class="mb-0">
          📈 Métricas de Atendimento
        </h4>
      </template>
      <div
        class="chart-container"
        style="height: 300px;"
      >
        <metricas-chart
          :chart-data="chartData"
          :options="options"
          :height="300"
        />
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { BCol, BCard } from 'bootstrap-vue'
import MetricasChart from '../MetricasChart.vue'

export default {
  name: 'MetricsChartCard',
  components: {
    BCol,
    BCard,
    MetricasChart,
  },
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({
        labels: [],
        datasets: [],
      }),
    },
    options: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>
.chart-container {
  position: relative;
}
</style>
